/* unplugin-vue-components disabled */import script from "./WOEntryExplanations.vue?vue&type=script&setup=true&lang=js"
export * from "./WOEntryExplanations.vue?vue&type=script&setup=true&lang=js"

import "./WOEntryExplanations.vue?vue&type=style&index=0&id=688dee06&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688dee06"]])

export default __exports__